import { Component, h, Prop, Host } from '@stencil/core';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * How it works component that displays step-by-step instructions
 * with icons and descriptions.
 *
 * @product signnow
 * @source hiw
 * @version 1.1.0
 * @category SignNow
 * @slot items - {required}, {multiple}, <div class="how-it-works__item"> - Step items with icons and text
 * @example
 *   <sn-how-it-works-type-1
 *     values='{"heading":"How it works"}'
 *   >
 *     <div slot="items" class="how-it-works__item">
 *       <div class="how-it-works__icon"><me-icon name="https://marketing-static.signnow.com/347/images/me/how-it-works/icon-1.svg"></me-icon></div>
 *       <div class="how-it-works__details"><strong>Open up</strong> a PDF file in the editor</div>
 *     </div>
 *   </sn-how-it-works-type-1>
 */
@Component({
  tag: 'sn-how-it-works-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SnHowItWorks {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  /**
   * @dynamic
   * @type {object}
   * @property {string} heading - Section heading text
   * @required heading
   */
  @Prop({ mutable: true }) values?: { heading?: string } | string;

  componentWillLoad() {
    this.values = parseJsonProp(this.values);
  }

  render() {
    const v = typeof this.values === 'object' && this.values !== null
      ? this.values as Record<string, string>
      : {};

    return (
      <Host data-color-mode={this.colorMode}>
        <div class="column">
          <me-heading tag="h2" class="section-side-title">
            {v.heading ?? 'How it works'}
          </me-heading>
          <div class="how-it-works">
            <slot name="items"></slot>
          </div>
        </div>
      </Host>
    );
  }
}
